import React from 'react';
import styled from 'styled-components';

import Card from 'antd/es/card';
import Divider from 'antd/es/divider';

import Grid from 'components/Grid';
import Statistics from 'components/Statistics';

const StyledStatsCard = styled(Card)`
  background-color: #FFFFFF;
  border-radius: 8px;
  border: none;

  & .ant-card-head-title {
    font-family: Inter;
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 20px;
    color: #828C94;
    padding: 16px 0 12px 0;
    text-transform: uppercase;
  }

  & .ant-card-head {
    min-height: unset;
    text-align: center;
    border-bottom: unset;
  }

  & .ant-card-body {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 16px 24px 16px;

    & .ant-statistic {
      width: 50%;
    }
  }
`;

const DoorActivityStats = ({ data = null }) => (
  <Grid gutter={24} columns={2} style={{ padding: '8px 0 16px' }}>
    <StyledStatsCard title="UNLOADS">
      <Statistics
        title="Equipment Unloaded"
        titleStyle={{ fontSize: '12px', lineHeight: '20px' }}
        value={data ? data.containers : ''}
        titleAlign={['center', 'bottom']}
      />
      <Divider type="vertical" style={{ height: '58px', margin: '0 2px' }} />
      <Statistics
        title="Cartons Unloaded"
        titleStyle={{ fontSize: '12px', lineHeight: '20px' }}
        value={data ? data.boxes_unloaded : ''}
        titleAlign={['center', 'bottom']}
      />
    </StyledStatsCard>
    <StyledStatsCard title="LOADS">
      <Statistics
        title="Equipment Loaded"
        titleStyle={{ fontSize: '12px', lineHeight: '20px' }}
        value={data ? data.trailers : ''}
        titleAlign={['center', 'bottom']}
      />
      <Divider type="vertical" style={{ height: '58px', margin: '0 2px' }} />
      <Statistics
        title="Cartons Loaded"
        titleStyle={{ fontSize: '12px', lineHeight: '20px' }}
        value={data ? data.boxes_loaded : ''}
        titleAlign={['center', 'bottom']}
      />
    </StyledStatsCard>
  </Grid>
);

export default DoorActivityStats;
